(function () {
  'use strict';

  const SELECTOR = '[data-ph-cart-shipping]';
  let refreshTimer = null;

  function formatMoney(cents) {
    return new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: 'MXN',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(Number(cents || 0) / 100);
  }

  function render(cart) {
    const root = document.querySelector(SELECTOR);
    if (!root || !cart) return;

    const itemCount = Number(cart.item_count || 0);
    const total = Number(cart.total_price || 0);
    const threshold = Number(root.dataset.threshold || 100000);
    const message = root.querySelector('[data-ph-cart-shipping-message]');
    const track = root.querySelector('[data-ph-cart-shipping-track]');
    const fill = root.querySelector('[data-ph-cart-shipping-fill]');

    root.dataset.cartCount = String(itemCount);
    root.classList.toggle('is-empty', itemCount === 0);
    root.hidden = itemCount === 0;

    if (itemCount === 0) return;

    const remaining = Math.max(0, threshold - total);
    const progress = Math.min(100, Math.max(0, (total / threshold) * 100));

    if (message) {
      message.innerHTML = remaining > 0
        ? `Estás a <strong>${formatMoney(remaining)}</strong> de tu <b>envío gratis</b> 🚚`
        : '<strong>¡Tu pedido ya tiene envío estándar gratis! 🎉</strong>';
    }

    if (fill) fill.style.width = `${progress}%`;
    if (track) track.setAttribute('aria-valuenow', String(Math.round(progress)));
  }

  async function fetchCart() {
    try {
      const response = await fetch('/cart.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      render(await response.json());
    } catch (error) {
      console.warn('[PH] No fue posible actualizar el progreso de envío.', error);
    }
  }

  function scheduleRefresh(delay = 80) {
    if (!document.querySelector(SELECTOR)) return;
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(fetchCart, delay);
  }

  function connectEvents() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        const cartData = event?.cartData;
        if (cartData && typeof cartData.total_price === 'number') {
          render(cartData);
        } else {
          scheduleRefresh();
        }
      });
    }

    document.addEventListener('ph:cart:updated', () => scheduleRefresh());
    document.addEventListener('rebuy:cart.change', () => scheduleRefresh());
    document.addEventListener('rebuy:cart.ready', () => scheduleRefresh());
    document.addEventListener('rebuy:smartcart.show', () => {
      document.body.classList.add('ph-rebuy-cart-open');
    });
    document.addEventListener('rebuy:smartcart.hide', () => {
      document.body.classList.remove('ph-rebuy-cart-open');
    });
    window.addEventListener('pageshow', () => scheduleRefresh(0));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', connectEvents, { once: true });
  } else {
    connectEvents();
  }
})();
